// extracted by mini-css-extract-plugin
module.exports = {"iconContainer":"NfcFormTooltip_iconContainer__YN6kI","icon":"NfcFormTooltip_icon__m3qDL"};